import * as Models from '@models';

export const modelsMap = new Map<string, any>([
  ['users', Models.User],
  ['getAssetFolder', Models.Folder],
  ['getBrandListing', Models.Brand],
  ['getProduct', Models.Product],
  ['getProductListing', Models.Product],
]);
